import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import RequestHelper from './RequestHelper';
import transformObjectResponseKeys from '../utils/transformObjectResponseKeys';
import { InitAppResponseKeys, UpdateAppEventResponseKeys, XPResponseKeys, FavouriteResponseKeys, Endpoints, LTOPackageItemKeys, OOCPackageItemKeys } from './Constants';
import transformObjectArrayResponse from '../utils/transformObjectArrayResponse';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import store from '../state/store';
import { setWelcomeBonus, setLTOOffer, setOutOfCoinOfferResponse, setTimedBonus, setIsWelcomeBonusConsumed } from '../state/actions/consumables';
import { setSaleAvailable, setPaymentProvider } from '../state/actions/shopList';
import { setCacheId } from '../state/actions/app';
import { setXpBetMultiplier } from '../state/slices/xp/xp';
import { setMaxDownloadedGames } from '../state/actions/gameDownload';
import { setWelcomeNews, setLobbyBackgroundPromo } from '../state/actions/promotions';
import { setAppsflyerGamesOpenedAmountConfig } from '../state/actions/playerInfo';
import { updateUnreadMessageCount } from '../state/actions/notification';
import { clearOnboarding, setFtueState, setFtueGameId } from '../state/actions/currentOnboarding';
import PushNotification from '../lib/notifications/PushNotification';
import QueryParamProxy from '../utils/queryParamProxy';
import Screens from '../screens';
import Utils from '../utils';
import TimeStampManager from '../utils/TimestampManager';
import RouteParamConstants from '../utils/routeParamConstants';
import ERROR_CODE from '../utils/errorCodes';
import { ltoCallBackHandler } from '../utils/function';
import { propertiesRequestData } from '../state/slices/properties/properties';
import { promoListHandler } from '../utils/PromotionAction';
import { getAssetsPackage } from '../state/query/assetsPackage';
export default {
  /**
   * Helper method to get kitchen sink info
   * @returns {Promise<InitAppResponseKeys>}
   */
  initApp: function () {
    var _initApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _callResponse, _callResponse2, response, callResponse, coinBalance, loyaltyPoints, preloadAssetsPackageIds, loginData, diveItems, queryParams;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.INIT_APP,
                logJSON: true
              }, false);

            case 3:
              response = _context.sent;
              callResponse = !!response && response || Array(7).fill({});
              console.log('call response', callResponse);

              if (!(callResponse.success === false)) {
                _context.next = 8;
                break;
              }

              throw Error("[Init-App-response] ".concat(callResponse.error));

            case 8:
              coinBalance = callResponse[3][0];
              loyaltyPoints = callResponse[3][2];
              callResponse = transformObjectResponseKeys(callResponse[0], InitAppResponseKeys);
              callResponse.PAYMENT_PROVIDER && store.dispatch(setPaymentProvider(callResponse.PAYMENT_PROVIDER));
              callResponse.APPSFLYER_GAMES_OPENED && store.dispatch(setAppsflyerGamesOpenedAmountConfig(callResponse.APPSFLYER_GAMES_OPENED)); // Call initProperty

              store.dispatch(propertiesRequestData()); // Update CacheId

              if (callResponse.CACHE_ID) {
                store.dispatch(setCacheId(callResponse.CACHE_ID));
              }

              if (callResponse.MAX_DOWNLOADED_GAMES) {
                store.dispatch(setMaxDownloadedGames(callResponse.MAX_DOWNLOADED_GAMES));
              }

              if (callResponse.ENABLE_FTUE != 'yes') {
                store.dispatch(clearOnboarding());
              } else {
                store.dispatch(setFtueState(true));
                if (callResponse.TUTORIAL_ID) store.dispatch(setFtueGameId(callResponse.TUTORIAL_ID));
              }

              if (callResponse.XP || callResponse.XP === 0) {
                callResponse.XP = transformObjectResponseKeys(callResponse.XP, XPResponseKeys);
              }

              callResponse.PROMOTIONS = transformObjectArrayResponse(callResponse.PROMOTIONS);
              callResponse.PROMOTIONS_SECOND = transformObjectArrayResponse(callResponse.PROMOTIONS_SECOND);
              callResponse.PROMOTIONS_THIRD = transformObjectArrayResponse(callResponse.PROMOTIONS_THIRD);
              callResponse.WELCOME = transformObjectArrayResponse(callResponse.WELCOME);

              if (callResponse.XP) {
                callResponse.XP.CURRENT_XP = parseInt(callResponse.XP.CURRENT_XP);
                callResponse.XP.XP_BET_MULTIPLIER = parseFloat(callResponse.XP.XP_BET_MULTIPLIER);
                callResponse.XP.XP_PER_SPIN = parseInt(callResponse.XP.XP_PER_SPIN);
              }

              if (callResponse.SETTINGS) {
                callResponse.SETTINGS.kyocInfo = {
                  iskyocdone: callResponse.SETTINGS.kyocInfo.iskyocdone === 'yes',
                  kyocresult: callResponse.SETTINGS.kyocInfo.kyocresult,
                  info: callResponse.SETTINGS.kyocInfo.info
                };
                callResponse.SETTINGS.soundEffects = callResponse.SETTINGS.soundEffects === 'true';
                callResponse.SETTINGS.music = callResponse.SETTINGS.music === 'true';
              }

              if (callResponse.FAVOURITE) {
                callResponse.FAVOURITE = transformObjectResponseKeys(callResponse.FAVOURITE, FavouriteResponseKeys);
              }

              callResponse.TUTORIAL = callResponse.TUTORIAL === 'yes';
              preloadAssetsPackageIds = ((_callResponse = callResponse) === null || _callResponse === void 0 ? void 0 : _callResponse.PRELOAD_ASSETS_PACKAGE_IDS) ? Object.values((_callResponse2 = callResponse) === null || _callResponse2 === void 0 ? void 0 : _callResponse2.PRELOAD_ASSETS_PACKAGE_IDS) : ['reward-center-global-default'];
              if ((preloadAssetsPackageIds === null || preloadAssetsPackageIds === void 0 ? void 0 : preloadAssetsPackageIds.length) > 0) preloadAssetsPackageIds.forEach(function (assetsPackageId) {
                return store.dispatch(getAssetsPackage.initiate({
                  assetsPackageId: assetsPackageId
                }));
              });
              loginData = Logger.loginData;

              if (loginData === null) {
                loginData = {
                  type: '',
                  email: ''
                };

                if (callResponse.CASINO_ID_STATUS === 'Guest') {
                  loginData.type = 'guest';
                }

                if (callResponse.SETTINGS) {
                  if (callResponse.SETTINGS.facebookId !== '') {
                    loginData.type = 'facebook';
                  }

                  if (callResponse.SETTINGS.googleId !== '') {
                    loginData.type = 'google';
                  }
                }
              }

              diveItems = {};

              if (callResponse.CASINO_ID_STATUS === 'Guest') {
                diveItems.loginMethod = 'guest';
              } else {
                if (callResponse.SETTINGS && callResponse.SETTINGS.facebookId !== '') {
                  diveItems.loginMethod = 'facebook';
                }

                if (callResponse.SETTINGS && callResponse.SETTINGS.googleId !== '') {
                  diveItems.loginMethod = 'google';
                }
              }

              diveItems.userXP = callResponse.XP.CURRENT_XP;
              diveItems.userLevel = callResponse.XP.LEVEL_META.currentLevel;
              diveItems.sessionId = store.getState().token.token;
              queryParams = QueryParamProxy.getAllParams();
              Logger.sendEvent(EVENT_TYPES.LOGIN_COMPLETE, {
                curr_xp: !!callResponse.XP && callResponse.XP.CURRENT_XP || 0,
                tier_id: !!callResponse.CURRENT_MEMBER_LEVEL && callResponse.CURRENT_MEMBER_LEVEL || 0,
                balance_before: coinBalance,
                loyalty_points_before: loyaltyPoints,
                is_member_linked: !!callResponse.SETTINGS && !!callResponse.SETTINGS.linkedCasinoId && callResponse.SETTINGS.linkedCasinoId === 'yes' && 1 || 0,
                is_notification_on: PushNotification.notificationsEnabled ? 1 : 0,
                verification_status: callResponse.CASINO_ID_STATUS,
                email: loginData.email,
                login_type: loginData.type,
                fb_id: !!callResponse.SETTINGS && callResponse.SETTINGS.facebookId || null,
                google_id: !!callResponse.SETTINGS && callResponse.SETTINGS.googleId || null,
                userID: store.getState().playerInfo.playerId,
                diveItems: diveItems,
                queryParams: queryParams
              });

              if (callResponse.WELCOMEBONUS != '') {
                store.dispatch(setWelcomeBonus(callResponse.WELCOMEBONUS));
              }

              if (callResponse.WELCOMEBONUS != '' && !callResponse.TUTORIAL === 'no') {
                store.dispatch(setIsWelcomeBonusConsumed(false));
              }

              return _context.abrupt("return", callResponse);

            case 42:
              _context.prev = 42;
              _context.t0 = _context["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t0, Object.getOwnPropertyNames(_context.t0)),
                code: ERROR_CODE.APP_INTERFACE_INIT_APP_CATCH
              });
              throw _context.t0;

            case 46:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 42]]);
    }));

    function initApp() {
      return _initApp.apply(this, arguments);
    }

    return initApp;
  }(),
  updateAppEvents: function () {
    var _updateAppEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response, callResponse, ltoResponse, messagesFromResponse, msgcount, outOfCoinsResponse, i, welcomeNewsReceivedPromise;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.UPDATE_APP_EVENT_INFO,
                logJSON: true
              }, false);

            case 3:
              response = _context2.sent;
              callResponse = !!response && response || Array(7).fill({});

              if (!(callResponse.success === false)) {
                _context2.next = 7;
                break;
              }

              throw Error("[Update-App-events-response] ".concat(callResponse.error));

            case 7:
              callResponse = transformObjectResponseKeys(callResponse[0], UpdateAppEventResponseKeys); // Update LTO

              if (callResponse.LIMITED_TIME_OFFER) {
                ltoResponse = transformObjectResponseKeys(callResponse.LIMITED_TIME_OFFER, LTOPackageItemKeys);
                ltoResponse.OFFER_END_TIME = ltoResponse.TIME_LEFT_IN_SEC * 1000 + Date.now();
                store.dispatch(setLTOOffer(ltoResponse));
                TimeStampManager.register(ltoResponse.TIME_LEFT_IN_SEC * 1000, ltoCallBackHandler(store, setLTOOffer));
              } // Unread Message count


              if (callResponse.MESSAGES && callResponse.MESSAGES.messages) {
                messagesFromResponse = transformObjectArrayResponse(callResponse.MESSAGES.messages);

                if (messagesFromResponse.length > 0) {
                  msgcount = messagesFromResponse.filter(function (msg) {
                    return !Utils.isEmpty(msg) && msg.message_read !== 'yes';
                  }).length;
                  store.dispatch(updateUnreadMessageCount(msgcount));
                }
              } // Update out of coins data


              if (callResponse.OUT_OF_COINS) {
                outOfCoinsResponse = transformObjectResponseKeys(callResponse.OUT_OF_COINS, OOCPackageItemKeys);
                store.dispatch(setOutOfCoinOfferResponse(outOfCoinsResponse));
              } // Update Promotions


              promoListHandler({
                first_slide: transformObjectArrayResponse(callResponse.PROMOTIONS),
                second_slide: transformObjectArrayResponse(callResponse.PROMOTIONS_SECOND),
                third_slide: transformObjectArrayResponse(callResponse.PROMOTIONS_THIRD)
              }); // Update Timed Bonus

              if (callResponse.TIMED_BONUS) {
                callResponse.TIMED_BONUS.timeLeft = Date.now() + callResponse.TIMED_BONUS.timeLeft * 1000;
                store.dispatch(setTimedBonus(callResponse.TIMED_BONUS));
              } // Update Sale


              store.dispatch(setSaleAvailable(callResponse.SALE)); // Update XP Bet Multiplier

              if (callResponse.XP_BOOST_MULTIPLIER) {
                store.dispatch(setXpBetMultiplier(callResponse.XP_BOOST_MULTIPLIER));
              } // Update Welcome news


              callResponse.WELCOME = transformObjectArrayResponse(callResponse.WELCOME);

              if (!(callResponse.WELCOME && callResponse.WELCOME.length > 0)) {
                _context2.next = 26;
                break;
              }

              i = 0;

            case 18:
              if (!(i < callResponse.WELCOME.length)) {
                _context2.next = 26;
                break;
              }

              store.dispatch(setWelcomeNews(callResponse.WELCOME[i]));
              welcomeNewsReceivedPromise = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.News));
              _context2.next = 23;
              return welcomeNewsReceivedPromise;

            case 23:
              i++;
              _context2.next = 18;
              break;

            case 26:
              // Update Lobby Background
              if (callResponse.LOBBY_BACKGROUND) {
                store.dispatch(setLobbyBackgroundPromo(callResponse.LOBBY_BACKGROUND));
              }

              _context2.next = 33;
              break;

            case 29:
              _context2.prev = 29;
              _context2.t0 = _context2["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context2.t0, Object.getOwnPropertyNames(_context2.t0)),
                code: ERROR_CODE.UPDATE_APP_EVENTS_FAIL
              });
              throw _context2.t0;

            case 33:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 29]]);
    }));

    function updateAppEvents() {
      return _updateAppEvents.apply(this, arguments);
    }

    return updateAppEvents;
  }(),

  /** Only relevant on the web, baked in at build time for mobile. */
  getFacebookAppId: function () {
    var _getFacebookAppId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var callResponse;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_FB_APP_ID
              }, false);

            case 2:
              callResponse = _context3.sent;
              return _context3.abrupt("return", callResponse && callResponse['0'] ? callResponse['0'] : false);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function getFacebookAppId() {
      return _getFacebookAppId.apply(this, arguments);
    }

    return getFacebookAppId;
  }()
};